import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

window.ClassicEditor = ClassicEditor;

export function initCKEditor() {
    document.querySelectorAll('[data-editor]').forEach(el => {
        if (!el.classList.contains('ckeditor-initialized')) {
            ClassicEditor
                .create(el)
                .then(() => el.classList.add('ckeditor-initialized'))
                .catch(error => console.error('CKEditor error:', error));
        }
    });
}


// ✅ Expose init function globally
window.initCKEditor = initCKEditor;